"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenu = UserMenu;
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _navigationItem = _interopRequireDefault(require("./navigation-item"));

var _withPopover = _interopRequireDefault(require("../with-popover"));

var _userUtil = require("../../util/user-util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Anchor(props) {
  var user = props.user;
  return /*#__PURE__*/_react["default"].createElement("span", null, (0, _userUtil.userDisplayName)(user));
}

Anchor.propTypes = {
  user: _propTypes["default"].shape({}).isRequired
};
/**
 * UserMenu is a sub navigation for User related routes on desktop sized screens.
 * It is rendered inside of a popover.
 */

function UserMenu(_ref) {
  var routes = _ref.routes,
      secondaryLinks = _ref.secondaryLinks,
      user = _ref.user;

  var subMenu = _lodash["default"].map(secondaryLinks, function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_navigationItem["default"], {
      tab: item,
      className: "clearLink"
    }));
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "UserMenu"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "secondaryLinks"
  }, subMenu), /*#__PURE__*/_react["default"].createElement("div", {
    className: "user"
  }, "Logged in as", /*#__PURE__*/_react["default"].createElement("span", {
    className: "full-name"
  }, (0, _userUtil.userFullName)(user))), /*#__PURE__*/_react["default"].createElement(_navigationItem["default"], {
    tab: routes.settings
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "divider"
  }, "|"), /*#__PURE__*/_react["default"].createElement(_navigationItem["default"], {
    tab: routes.logout
  }));
}

UserMenu.propTypes = {
  routes: _propTypes["default"].shape({
    settings: _propTypes["default"].object,
    logout: _propTypes["default"].object,
    login: _propTypes["default"].object
  }),
  user: _propTypes["default"].shape({}).isRequired,
  secondaryLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    text: _propTypes["default"].string
  }))
};
UserMenu.defaultProps = {
  secondaryLinks: [],
  routes: {}
};

var _default = (0, _withPopover["default"])(Anchor, UserMenu, {
  anchorTargetAlign: 'end',
  anchorClass: 'UserMenuAnchor clearButton'
});

exports["default"] = _default;